import React from 'react';

const ProviderInfo = ({ moreThanOne, isBillingProvider, idx, provider }) => {
  const nameLabel = (
    <div className="flex gap-1">
      <span className="text-sm font-400 text-neutral-900">
        {provider?.bill_name || provider?.fullName}
      </span>
    </div>
  );

  const npiLabel = (
    <div className="flex gap-1">
      <span className="text-sm font-400 text-neutral-500">
        NPI:{provider?.bill_npi || provider?.billingInfo?.npi}
      </span>
    </div>
  );

  return (
    <div className="flex w-full justify-between gap-1">
      {!moreThanOne ? (
        <div className="flex w-full flex-col justify-between">
          <span className="py-1 text-xs font-500 text-primary-600">
            {isBillingProvider ? 'Billing Provider' : 'Rendering Provider'}
          </span>
          <div className="flex w-full items-center justify-between gap-2">
            <div className="flex items-center gap-2">
              <div className="mt-[2px] flex size-4 place-content-center rounded-full border border-solid border-neutral-200 bg-neutral-50">
                <span className="text-xxs font-500 leading-[14px] text-neutral-600">{idx + 1}</span>
              </div>
              {nameLabel}
            </div>
            {npiLabel}
          </div>
        </div>
      ) : (
        <div className="flex w-full items-center justify-between gap-2">
          <div className="flex items-center gap-2">
            <div className="mt-[2px] flex size-4 place-content-center rounded-full border border-solid border-neutral-200 bg-neutral-50">
              <span className="text-xxs font-500 leading-[14px] text-neutral-600">{idx + 1}</span>
            </div>
            <p>{nameLabel}</p>
          </div>
          <p>{npiLabel}</p>
        </div>
      )}
    </div>
  );
};

export default ProviderInfo;
